import { useMutation } from "react-query";
import ocrUpload from "../services/ocrUpload";

const useOcrUpload = () => {
  return useMutation(["ocr-upload"], ocrUpload);
};

export default useOcrUpload;
